<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>Firma kontaktieren</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close({contacted})">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main :class="['scrollbar-check', 'bg-lightest-blue', { 'flex-grow-1': contacted }]">
			<JonInfo>
				<template #message>
					<div>
						<b>Möchtest du den Arbeitgeber kontaktieren?</b><br/>
						Das passiert, wenn du "<b>Anonym kontaktieren</b>" bestätigst:
					</div>
					<ol class="pl-3 mt-3">
						<li>
							Wir senden deine anonyme Kontaktanfrage an den Arbeitgeber.
						</li>
						<li>
							Der Arbeitgeber sieht dein anonymes Profil und das "Matching"/die Übereinstimmung, er
							sieht aber weder deinen Namen, noch deine Kontaktdaten, dein Alter oder deinen Wohnort und
							auch noch nicht deinen Lebenslauf oder den Namen bisheriger Arbeitgeber (wenn du das schon
							eingetragen hast).
						</li>
						<li>
							Nimmt der Arbeitgeber die anonyme Kontaktanfrage an, dann erfährst du den Namen des
							Arbeitgebers, deine Ansprechperson für den Job und die nächsten Schritte.
						</li>
						<li>
							Dann kannst du entscheiden, ob du an weiteren Schritten mit dem Arbeitgeber interessiert
							bist und deinen Namen offenlegst.
						</li>
					</ol>
					<p>Viel Erfolg!</p>
				</template>
			</JonInfo>
			<div v-if="contacted" class="message-list mt-4">
				<div class="message-list--items">
					<ListItem
						custom-text="<b>Kontaktanfrage erfolgreich gesendet</b><br/>Sobald die Firma antwortet, erhältst du weitere Infos."
						:custom-time-stamp="new Date()"
					 	:is-recipient="false"
						force-right
						icon="checkmark"
					/>
				</div>
			</div>
		</main>
		<footer v-if="!contacted">
			<div class="flex-grow-1 text-right">
				<Button
					text="Anonym kontaktieren"
					icon="checkmark"
					:disabled="contacting"
					:loading="contacting"
					@click="contact"
				/>
			</div>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Button from "@/vue/common/Button";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/communication/contact-job-profile";
import Contact from "@/api/communication/conversation/customer/Contact";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import JonInfo from "@/vue/common/JonInfo.vue";
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";

export default {

	components: {
		ListItem,
		JonInfo,
		Button,
		Icon,
	},

	data ()
	{
		return {
			contactData: undefined,
			contacting: false,
			contacted: false,
		};
	},

	computed: {
		...mapState('communication/contactJobProfile', [
			'show',
			'jobProfileId',
			'jobProfileName',
			'jobId',
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
	},

	methods: {
		...mapActions('communication/contactJobProfile', [
			'close'
		]),
		async contact ()
		{
			this.contacting = true;

			try
			{
				await new Contact()
					.setJobProfile(this.jobProfileId)
					.setJob(this.jobId)
					.call();

				this.contacted = true;
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.contacting = false;
		}
	},
}
</script>
